//* Libraries imports
import { Button } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaSpinner, FaCheck } from 'react-icons/fa';
import { buttonVariants, formItemVariants } from '../animations';

//* Components imports
import Icon from "../../../../../../components/common/Icon";

type ActionButtonsProps = {
  isSubmitting: boolean;
  isSuccess?: boolean;
  isEditMode?: boolean;
  onCancel: () => void;
};

export function ActionButtons({
  isSubmitting,
  isSuccess = false,
  isEditMode,
  onCancel,
}: ActionButtonsProps) {
  return (
    <motion.div
      className="d-flex justify-content-end"
      variants={formItemVariants}
      custom={10}
    >
      <motion.div
        variants={buttonVariants}
        whileHover="hover"
        whileTap="tap"
        className="me-2"
      >
        <Button
          id="cancelButton"
          type="button"
          variant="outline-secondary"
          title="Cancelar e voltar"
          aria-label="Cancelar e voltar"
          disabled={isSubmitting}
          onClick={onCancel}
        >
          Cancelar
        </Button>
      </motion.div>

      <motion.div variants={buttonVariants} whileHover="hover" whileTap="tap">        <Button
          id="submitButton"
          type="submit"
          variant={isSuccess ? "success" : "primary"}
          disabled={isSubmitting || isSuccess}
          title={isEditMode ? "Atualizar recurso" : "Enviar recurso"}
          aria-label={isEditMode ? "Atualizar recurso" : "Enviar recurso"}
        >{isSuccess ? (
            <>
              <Icon icon={FaCheck} className="me-2" />
              {isEditMode ? "Atualizado!" : "Enviado!"}
            </>
          ) : isSubmitting ? (
            <>
              <Icon icon={FaSpinner} className="spinner me-2" />
              {isEditMode ? "Atualizando..." : "Enviando..."}
            </>
          ) : isEditMode ? (
            "Atualizar Recurso"
          ) : (
            "Enviar Recurso"
          )}
        </Button>
      </motion.div>
    </motion.div>
  );
}
